export default 40000;
